import { SVGProps, memo } from 'react';

const SitemapIcon = ({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = '#212121',
  radius = 8,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx={radius} fill={fill} fillOpacity={props.fillOpacity ?? 1} />
      <rect x="9.4498" y="4.65049" width="5.09976" height="5.09976" stroke={stroke} strokeWidth="1.3" />
      <rect x="4.65" y="16.3829" width="2.96651" height="2.96651" stroke={stroke} strokeWidth="1.3" />
      <rect x="10.5162" y="16.3829" width="2.96651" height="2.96651" stroke={stroke} strokeWidth="1.3" />
      <rect x="16.3834" y="16.3829" width="2.96651" height="2.96651" stroke={stroke} strokeWidth="1.3" />
      <path
        d="M12.0002 10.3999V13.0665M12.0002 15.733V13.0665M12.0002 13.0665H6.13379V15.733M12.0002 13.0665H17.8667V15.9997"
        stroke={stroke}
        strokeWidth="1.3"
      />
    </svg>
  );
};

export default memo(SitemapIcon);
